export const getTimelineStatusMap = ({ stepId }) => {
  switch (stepId) {
    case 'pan-details':
      return {
        key: 'pan_status',
        title: 'Pan Details'
      };
    case 'business-details':
      return {
        key: 'business_details_status',
        title: 'Business Details'
      };
    case 'bank-details':
      return {
        key: 'bank_status',
        title: 'Bank Account',
      };
    case 'website-details':
      return {
        key: 'website_status',
        title: 'App/ Website Details',
      };
    case 'additional-documents':
      return {
        key: 'document_status',
        title: 'KYC Documents',
      };
    default:
      return null;
  }
};

export const getSkippedSteps = ({ attachedConfigs }) => {
  let skippedList = [];

  if (
    attachedConfigs &&
    attachedConfigs.length
  ) {
    const skipStepConfigs = attachedConfigs.find((config) => (
      config.active &&
      config.name === "skip_onboarding_steps"
    ));

    if (
      skipStepConfigs &&
      skipStepConfigs.config &&
      skipStepConfigs.config.onboarding_steps &&
      skipStepConfigs.config.onboarding_steps.documentation
    ) {
      if (skipStepConfigs.config.onboarding_steps.documentation.agreement_required === false)
        skippedList = skippedList.concat('service-agreement');
      if (skipStepConfigs.config.onboarding_steps.documentation.kyc_docs_upload_required === false)
        skippedList = skippedList.concat(['kyc', 'additional-documents']);

      // skip_onboarding steps logic
      if (skipStepConfigs.config.onboarding_steps.website_details_required === false)
        skippedList = skippedList.concat(['website-details']);
      if (skipStepConfigs.config.onboarding_steps.signing_authority_details_required === false)
        skippedList = skippedList.concat(['signing-authority']);
      if (skipStepConfigs.config.onboarding_steps.aadhar_ckyc_address_required === false)
        skippedList = skippedList.concat(['kyc']);
      if (skipStepConfigs.config.onboarding_steps.business_members_details_required === false)
        skippedList = skippedList.concat(['management-details']);
    }
  }
  return skippedList;
};